module.exports = __webpack_public_path__ + "img/Facturi.5759f978.png";